__turbopack_context__.v({
  "action": "DspsZG_action",
  "card": "DspsZG_card",
  "imageContainer": "DspsZG_imageContainer",
  "stack": "DspsZG_stack",
  "text": "DspsZG_text",
  "title": "DspsZG_title",
});
